<mat-card class="cardWithShadow">
  <mat-card-content style="padding: 36px 36px 0px 36px">
    <h2>Reporte de Stock</h2>

    <div
      *ngIf="isLoading"
      class="d-flex flex-col flex-wrap align-items-center justify-content-center"
      style="padding-bottom: 36px"
    >
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
      <p>Cargando Reporte...</p>
    </div>

    <div *ngIf="!isLoading" class="w-100">
      <div class="col-sm-4 w-100">
        <mat-form-field appearance="outline" class="w-100 hide-hint">
          <mat-label>Categoría</mat-label>
          <mat-select
            [(value)]="selectCategoria"
            (selectionChange)="applyFilterSelect()"
          >
            <mat-option value="{{ null }}">No seleccionar</mat-option>
            <mat-option
              *ngFor="let categoria of arrayCategorias"
              value="{{ categoria }}"
              >{{ categoria }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="col-sm-4 w-100">
      <mat-form-field appearance="outline" class="w-100 hide-hint">
        <input matInput placeholder="Buscar..." (keyup)="applyFilter($event)" />
        <mat-icon matSuffix>
          <i-tabler name="search" class="icon-20"></i-tabler>
        </mat-icon>
      </mat-form-field>
    </div>
  </mat-card-content>

  <mat-card-content
    [style.display]="
      !isLoading && dataSource.filteredData.length !== 0 ? 'block' : 'none'
    "
    style="padding: 36px"
  >
    <div class="table-responsive">
      <table
        mat-table
        matSort
        [dataSource]="dataSource"
        class="no-wrap m-t-0 v-middle w-100"
      >
        <ng-container matColumnDef="id">
          <th
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
            mat-header-cell
            *matHeaderCellDef
          >
            Código
          </th>
          <td class="f-s-14 custom-column" mat-cell *matCellDef="let element">
            {{ element?.codigoInsumo }}
          </td>
        </ng-container>

        <ng-container matColumnDef="nombreInsumo">
          <th
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
            mat-header-cell
            *matHeaderCellDef
          >
            Nombre
          </th>
          <td class="f-s-14 custom-column" mat-cell *matCellDef="let element">
            {{ element?.nombreInsumo }}
          </td>
        </ng-container>

        <ng-container matColumnDef="categoria">
          <th
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
            mat-header-cell
            *matHeaderCellDef
          >
            Categoría
          </th>
          <td class="f-s-14 custom-column" mat-cell *matCellDef="let element">
            {{ element?.categoria }}
          </td>
        </ng-container>

        <ng-container matColumnDef="peso">
          <th
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
            mat-header-cell
            *matHeaderCellDef
          >
            Peso
          </th>
          <td class="f-s-14 custom-column" mat-cell *matCellDef="let element">
            {{ element?.peso }}
          </td>
        </ng-container>

        <ng-container matColumnDef="unidadMedida">
          <th
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
            mat-header-cell
            *matHeaderCellDef
          >
            Unidad de Medida
          </th>
          <td class="f-s-14 custom-column" mat-cell *matCellDef="let element">
            {{ element?.unidadMedida }}
          </td>
        </ng-container>

        <ng-container matColumnDef="costo">
          <th
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
            mat-header-cell
            *matHeaderCellDef
          >
            Costo
          </th>
          <td class="f-s-14 custom-column" mat-cell *matCellDef="let element">
            {{
              element?.historialCostos?.length
                ? element.historialCostos[element.historialCostos.length - 1]
                    ?.costo
                : 0
            }}
          </td>
        </ng-container>

        <ng-container matColumnDef="stock">
          <th
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
            mat-header-cell
            *matHeaderCellDef
          >
            Stock
          </th>
          <td class="f-s-14 custom-column" mat-cell *matCellDef="let element">
            {{ element?.stock | number: '1.2-2' }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>

    <div>
      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
      </mat-paginator>
    </div>
  </mat-card-content>
  <div
    *ngIf="!isLoading && dataSource?.filteredData?.length === 0"
    class="d-flex justify-content-center align-items-center"
    style="width: 100%; height: 400px; text-align: center"
  >
    Lo sentimos. No tenemos datos para esta búsqueda.
    <br />Por favor, intenta con otro término.
  </div>
</mat-card>
